import React, { useState, useEffect } from "react";
import { getFormattedFullOrderTimeLeft } from "./global";

const useIfOrderSessionTimedout = (order_created_at, timeout) => {
    const [isExpired, set_isExpired] = useState(false);

    useEffect(() => {
        if (!order_created_at || !timeout) return;
        
        const interval = setInterval(() => {
            const newTime = getFormattedFullOrderTimeLeft(order_created_at, timeout);
            if (newTime === '00:00') {
                set_isExpired(true);

                clearInterval(interval);
            }
        }, 1000);
    
        return () => clearInterval(interval);
      }, [order_created_at, timeout]);
    
    return isExpired;
};

export default useIfOrderSessionTimedout;